import request from '../request/request.js'
import qs from 'qs'
//获取搜索标签
export const GetCareerTagAPI=()=>request.get('/home/getCareerTag');
//获取热门职业推荐
export const HotCareerAPI=()=>request.get('/home/hotCareer');

//获取热门企业
export const HotEnterpriseAPI=(currentPage)=>request.get('/home/hotEnterprise?'+qs.stringify({currentPage}));
//获取轮播图
export const GetBannerAPI =()=> request.get(`/home/banner`)


//通过id获取职业的详情页
export const CareerDetailInfoAPI=(id)=>request.get(`/detail/getCareerDetail/${id}`)
//通过id获取公司的详情页-top
export const CompanyDetailTopInfoAPI=(id)=>request.get(`/detail/getCompanyTopById/${id}`)

//公司部分职业
export const CompanyPartCareerAPI=(id,careerId)=>request.get(`/detail/getCompanyPartCareerByCompanyId/${id}/${careerId}`)

//通过id获取公司的详情页-button
export const CompanyDetailButtonInfoAPI=(id)=>request.get(`/detail/getCompanyDetailById/${id}`)

//获取公司中热门职业的分页信息
export const CompanyHotCareerPageAPI=(condition)=>request.post(`/page/getCompanyHotCareerPage`,condition)

//获取相册信息
export const GetAlbumInfoAPI =(companyId)=> request.get(`/detail/albumInfo/${companyId}`)



